"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDedicationCss = void 0;
const getDedicationCss = (themeId) => {
    return `
    .${themeId} .dedication{
      padding-top: 33.33%;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    
    .${themeId} .dedication * {
      text-align: center;
    }
  `;
};
exports.getDedicationCss = getDedicationCss;
